import {
  useModalStore,
  useProcessCreationLoadingStore,
  useProcessSocketStore,
} from "@/entities"
import type { ContentFromUrlDto } from "@/shared/api/generated"
import { SOCKET_ROUTES } from "@/shared/constants"
import { Modal } from "@/shared/types"
import { useForm } from "react-hook-form"

export function useCreateNoteWebUrl() {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<ContentFromUrlDto>({
    defaultValues: {
      url: "",
    },
  })

  const closeModal = useModalStore(s => s.closeModal)

  return {
    errors,
    control,
    handleSubmit: handleSubmit(values => {
      closeModal(Modal.CREATE_CONTENT_WITH_WEB_URL)
      useProcessCreationLoadingStore.getState().startAppLoading()

      useProcessSocketStore
        .getState()
        .emitToProcessSocket(SOCKET_ROUTES.CONTENT_FROM_URL, {
          url: values.url,
        })
    }),
    setValue,
  }
}
